import {
  Link,
  Text,
  TableColumnDefinition,
  Tooltip,
  createTableColumn,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  ToolbarButton,
  Image,
  Button,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import i18n from "i18next";
import useWindowSize from "../../helpers/useWindowSize";
import {
  ArrowCircleDownRegular,
  DocumentArrowRightRegular,
  MoreVerticalRegular,
  SearchSettingsRegular,
  ShoppingBagAddRegular,
} from "@fluentui/react-icons";
import { baseUrl } from "../../helpers/constants";
import { helperMethods } from "../../helpers/helperMethods";
import { MmInch } from "../../helpers/mminch";
import { IAddUserBedarfPosition } from "../../Models/IAddUserBedarfPosition";
//Props
interface IQuickFinderColumnsProps {
  type: string;
  showButtons: boolean;
  preiseSichtbar: boolean;
  selectedAbtriebsprofilGuid: string;
  openInNewTab?: boolean;
  onAddBedarf(item: IAddUserBedarfPosition): void;
  onShowPdf(item: string | undefined): void;
  onDownloadKvm(item: string | undefined): void;
  onGetAbtriebsZahnräder(item: string | undefined): void;
  onOrderBy?(column: string): void;
}

function QuickFinderColumns(props: IQuickFinderColumnsProps) {
  const navigate = useNavigate();

  const windowSize = useWindowSize();

  const allLsp3ColumnNames = [
    "artikelId",
    "actions",
    "benennungDE",
    "benennungEN",
    "sachgruppe",
    "gewicht",
    "preis",
  ];
  const lsp3_o_ColumnNames = [
    "artikelId",
    "actions",
    "benennungMl",
    "getriebe-maxAbtriebsmoment",
    "maxHexSize",
    "radius",
    "oeffnungsweite",
    "kopfmass",
    "klingenstaerke",
    "breite",
    "achsabstand",
    "auskraglaenge",
    "anzahlStufen",
    "preis",
  ];
  const lsp3_c_ColumnNames = [
    "artikelId",
    "actions",
    "benennungMl",
    "getriebe-maxAbtriebsmoment",
    "maxHexSize", // RADIUS FEHLT?
    "radius",
    "klingenstaerke",
    "breite",
    "achsabstand",
    "auskraglaenge",
    "anzahlStufen",
    "preis",
  ];
  const straightColumnNames = ["artikelId", "actions", "benennungMl", "preis"];
  const abtriebszahnradColumnNames = [
    "artikelId",
    "actions",
    "maxAbtriebsmoment",
    "benennungMl",
    "nennweite",
    "nennweiteInch",
    "oeffnungsweite",
    "laenge",
    "aussenlaenge",
    "schraubprofil",
    "profiltiefe",
    "preis",
  ];
  const abtriebgegenhalterColumnNames = [
    "artikelId",
    "actions",
    "benennungMl",
    "maxDrehmoment",
    "profilAbtrieb",
    "nennweiteAbtrieb",
    "gesamtlaengeGegenhalter",
    "aussenlaengeBit",
    "aussenlaengeAbtrieb",
    "preis",
  ];

  let folder = "";

  switch (props.type) {
    case "allLsp3":
      folder = "";
      break;
    case "lsp3_o_inline":
      folder = "INLINE_OFFEN";
      break;
    case "lsp3_c_inline":
      folder = "INLINE_GESCHLO";
      break;
    case "lsp3_o_outline":
      folder = "FL_OFFEN";
      break;
    case "lsp3_c_outline":
      folder = "FL_GESCHL";
      break;
    case "abtriebszahnrad":
      folder = "ZAB";
      break;
  }

  const columns: TableColumnDefinition<ILSP3ResponseDto>[] = [
    // ------------Artikel------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("artikelId");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              content={i18n.t<string>("artikelIdTooltip")}
              relationship="label"
            >
              <Text> {i18n.t<string>("artikelId")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        if (windowSize.width > 500) {
          if ((item.guid || item.artikel.guid) && item.hasSachwerte) {
            return (
              <Tooltip
                content={i18n.t<string>("displayTechnicalData")}
                relationship="label"
              >
                <div>
                  {item.artikelId.startsWith("P") == false && (
                    <Link
                      target="_blank"
                      href={`${baseUrl}/quickfinder?guid=${
                        item.guid ?? item.artikel.guid
                      }`}
                    >
                      {item.artikelId}
                    </Link>
                  )}
                  {item.artikelId.startsWith("P") == true && (
                    <Text>{item.artikelId}</Text>
                  )}
                </div>
              </Tooltip>
            );
          } else {
            return <Text>{item.artikelId}</Text>;
          }
        } else {
          <div>
            <Text>{item.artikelId}</Text>
            <Text>
              {item.artikel ? item.artikel.benennungDE : item.benennungDE}
            </Text>
          </div>;
        }
      },
    }),
    // ------------Actions------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "actions",
      renderHeaderCell: () => {
        return <div></div>;
      },
      renderCell: (item) => {
        const menuItems: any[] = [];

        if (item.isErsatz || item.artikel?.isErsatz) {
          let benennung = "";

          if (i18n.language.includes("de")) {
            benennung = item.artikel
              ? item.artikel.benennungDE
              : item.benennungDE;
          } else {
            benennung = item.artikel
              ? item.artikel.benennungEN
              : item.benennungEN;
          }

          menuItems.push({
            key: "addToBedarf",
            iconProps: <ShoppingBagAddRegular />,
            text: i18n.t<string>("addToBedarf"),
            onClick: () => {
              props.onAddBedarf({
                artikel: item.artikelId,
                produkt: undefined,
                benennung: benennung,
                kundenReferenz:
                  "Quick Finder " + new Date().toLocaleDateString(),
                menge: 1,
                reference: undefined,
              });
            },
          });
        }

        if (item.hasPrzDocument) {
          menuItems.push({
            disabled: false,
            key: "showPrz",
            iconProps: <DocumentArrowRightRegular />,
            text: i18n.t<string>("showPRZ"),
            onClick: () => {
              props.onShowPdf(item.artikelId);
            },
          });
        }

        if (item.hasKvmDocument) {
          menuItems.push({
            disabled: false,
            key: "downloadKvm",
            iconProps: <ArrowCircleDownRegular />,
            text: i18n.t<string>("downloadKvm"),
            onClick: () => {
              props.onDownloadKvm(item.artikelId);
            },
          });
        }

        if (
          item?.sachgruppe?.name == "Flachabtrieb" ||
          item?.artikel?.sachgruppe?.name == "Flachabtrieb"
        ) {
          menuItems.push({
            disabled: false,
            key: "getAbtriebszahnraeder",
            iconProps: <SearchSettingsRegular />,
            text: i18n.t<string>("getAbtriebszahnraeder"),
            onClick: () => {
              props.onGetAbtriebsZahnräder(item.artikelId);
            },
          });
        }

        if (menuItems.length > 0 && menuItems.length < 2) {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              {menuItems.map((item) => {
                return (
                  <Tooltip content={item.text} relationship={"label"}>
                    <Button
                      appearance="transparent"
                      icon={item.iconProps}
                      onClick={item.onClick}
                    />
                  </Tooltip>
                );
              })}
            </div>
          );
        } else if (menuItems.length > 1) {
          return (
            <Menu>
              <MenuTrigger>
                <ToolbarButton
                  aria-label="More"
                  icon={<MoreVerticalRegular />}
                />
              </MenuTrigger>

              <MenuPopover>
                <MenuList>
                  {menuItems.map((item) => {
                    return (
                      <MenuItem
                        onClick={() => {
                          item.onClick();
                        }}
                        icon={item.iconProps}
                      >
                        {item.text}
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </MenuPopover>
            </Menu>
          );
        }
      },
    }),
    // ------------BENNENUNG-DE------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungDE",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("benennungDE");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Text> {i18n.t<string>("benennungDE")}</Text>
          </div>
        );
      },
      renderCell: (item) => {
        return <Text>{item.benennungDE}</Text>;
      },
    }),
    // ------------BENNENUNG-EN------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungEN",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennungEN")}</Text>;
      },
      renderCell: (item) => {
        return <Text>{item.benennungEN}</Text>;
      },
    }),
    // ------------Sachgruppe------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "sachgruppe",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("sachgruppe")}</Text>;
      },
      renderCell: (item) => {
        if (item.hasOwnProperty("sachgruppe")) {
          return (
            <div className="lueb-centerVertical">
              <Text>
                {i18n.language.includes("de")
                  ? item.sachgruppe?.benennungDE
                  : item.sachgruppe?.benennungEN}
              </Text>
            </div>
          );
        } else {
          return <span></span>;
        }
      },
    }),
    // ------------Gewicht------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "gewicht",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("gewichtKg")}</Text>;
      },
      renderCell: (item) => {
        if (item.hasOwnProperty("sachgruppe")) {
          return (
            <div className="lueb-centerVertical">
              <Text>{item.gewicht ? item.gewicht?.toLocaleString() : "-"}</Text>
            </div>
          );
        } else {
          return <span></span>;
        }
      },
    }),
    // ------------benennungMl------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungMl",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy(
                  i18n.language.includes("de") ? "benennungDE" : "benennungEN"
                );
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Text> {i18n.t<string>("benennung")}</Text>
          </div>
        );
      },
      renderCell: (item) => {
        let benennung = "";
        if (item.hasOwnProperty("artikel")) {
          if (item.artikel) {
            benennung = i18n.language.includes("de")
              ? item.artikel.benennungDE
              : item.artikel.benennungEN;
          }
        }
        return (
          <div className="lueb-centerVertical">
            <Text>{benennung}</Text>
          </div>
        );
      },
    }),
    // ------------schraubprofil------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "schraubprofil",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy(
                  i18n.language.includes("de")
                    ? "displayNameDE"
                    : "displayNameEN"
                );
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              content={i18n.t<string>("schraubprofilTooltip")}
              relationship="label"
            >
              <Text> {i18n.t<string>("schraubprofilCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        if (
          props.selectedAbtriebsprofilGuid != "" &&
          item.profil &&
          item.profil?.schraubprofilGuid != props.selectedAbtriebsprofilGuid
        ) {
          return (
            <Tooltip
              content={<Text>{i18n.t<string>("konfDiffSchraubprofil")}</Text>}
              relationship="label"
            >
              <div
                style={{
                  backgroundColor: "red",
                  borderRadius: 5,
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: 5,
                  paddingRight: 5,
                }}
              >
                <Text style={{ color: "white" }}>
                  {i18n.language.includes("de")
                    ? item.profil?.displayNameDE
                    : item.profil?.displayNameEN}
                </Text>
              </div>
            </Tooltip>
          );
        } else {
          return (
            <div className="lueb-centerVertical">
              <Text>
                {i18n.language.includes("de")
                  ? item.profil?.displayNameDE
                  : item.profil?.displayNameEN}
              </Text>
            </div>
          );
        }
      },
    }), // ------------getriebe-maxAbtriebsmoment------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "getriebe-maxAbtriebsmoment",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("maxAbtriebsmoment");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={i18n.t<string>("getriebe-maxAbtriebsmomentTooltip")}
            >
              <Text>{i18n.t<string>("getriebe-maxAbtriebsmoment")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        if (item.hasOwnProperty("getriebe")) {
          if (item.getriebe) {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.getriebe?.maxAbtriebsmoment
                    ? item.getriebe?.maxAbtriebsmoment?.toLocaleString()
                    : ""}
                </Text>
              </div>
            );
          } else {
            return <span></span>;
          }
        } else {
          return <span></span>;
        }
      },
    }),
    // ------------maxAbtriebsmoment------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "maxAbtriebsmoment",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("maxAbtriebsmoment");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={i18n.t<string>("maxAbtriebsmomentTooltip")}
            >
              <Text>{i18n.t<string>("maxAbtriebsmomentCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.maxAbtriebsmoment
              ? item.maxAbtriebsmoment?.toLocaleString()
              : "-"}
          </Text>
        );
      },
    }),
    // ------------maxDrehmoment------------
    createTableColumn<any>({
      columnId: "maxDrehmoment",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("maxDrehmoment");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={i18n.t<string>("maxAbtriebsmomentTooltip")}
            >
              <Text>{i18n.t<string>("maxAbtriebsmomentCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.maxDrehmoment ? item.maxDrehmoment?.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------profilAbtrieb------------
    createTableColumn<any>({
      columnId: "profilAbtrieb",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("gesamtlaengeGegenhalter");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={i18n.t<string>("profilAbtriebTooltip")}
            >
              <Text>{i18n.t<string>("profilAbtriebCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return <Text>{item.profilAbtrieb}</Text>;
      },
    }),
    // ------------gesamtlaengeGegenhalter------------
    createTableColumn<any>({
      columnId: "gesamtlaengeGegenhalter",
      renderHeaderCell: () => {
        return (
          <Tooltip
            relationship="label"
            content={i18n.t<string>("gesamtlaengeGegenhalter")}
          >
            <Text>{i18n.t<string>("gesamtlaengeGegenhalterCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.gesamtlaengeGegenhalter
              ? item.gesamtlaengeGegenhalter?.toLocaleString()
              : "-"}
          </Text>
        );
      },
    }),
    // ------------aussenlaengeBit------------
    createTableColumn<any>({
      columnId: "aussenlaengeBit",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("aussenlaengeBit");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={i18n.t<string>("aussenlaengeBitTooltip")}
            >
              <Text>{i18n.t<string>("aussenlaengeBitCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.aussenlaengeBit
              ? item.aussenlaengeBit?.toLocaleString()
              : "-"}
          </Text>
        );
      },
    }), // ------------aussenlaengeAbtrieb------------
    createTableColumn<any>({
      columnId: "aussenlaengeAbtrieb",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("aussenlaengeAbtrieb");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={i18n.t<string>("aussenlaengeAbtriebTooltip")}
            >
              <Text>{i18n.t<string>("aussenlaengeAbtriebCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.aussenlaengeAbtrieb
              ? item.aussenlaengeAbtrieb?.toLocaleString()
              : "-"}
          </Text>
        );
      },
    }),

    // ------------maxHexSize------------
    createTableColumn<any>({
      columnId: "maxHexSize",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("maxHexSize");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={i18n.t<string>("maxHexSizeTooltip")}
            >
              <Text>{i18n.t<string>("maxHexSize")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.maxHexSize ? item.maxHexSize?.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------radius------------
    createTableColumn<any>({
      columnId: "radius",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("radius");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  <Image
                    width="400px"
                    src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MAX_RADIUS.JPG`}
                  ></Image>
                  <div>Radius</div>
                </div>
              }
            >
              <Text>R [mm]</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return <Text>{item.radius ? item.radius?.toLocaleString() : "-"}</Text>;
      },
    }),
    // ------------oeffnungsweite------------
    createTableColumn<any>({
      columnId: "oeffnungsweite",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("oeffnungsweite");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  <Image
                    width="400px"
                    src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MIN_OEFFNUNGSWEITE.JPG`}
                  ></Image>
                  <div>{i18n.t<string>("oeffnungsweiteTooltip")}</div>
                </div>
              }
            >
              <Text> {i18n.t<string>("oeffnungsweite")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.oeffnungsweite ? item.oeffnungsweite?.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------kopfmass------------
    createTableColumn<any>({
      columnId: "kopfmass",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("kopfmass");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  <Image
                    width="400px"
                    src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MAX_KOPFMASS.JPG`}
                  ></Image>
                  <div>{i18n.t<string>("kopfmassTooltip")}</div>
                </div>
              }
            >
              <Text>{i18n.t<string>("kopfmass")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>{item.kopfmass ? item.kopfmass?.toLocaleString() : "-"}</Text>
        );
      },
    }),
    // ------------klingenstaerke------------
    createTableColumn<any>({
      columnId: "klingenstaerke",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("klingenstaerke");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  <Image
                    width="400px"
                    src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MAX_KLINGENSTAERKE.JPG`}
                  ></Image>
                  <div>{i18n.t<string>("klingenstaerkeTooltip")}</div>
                </div>
              }
            >
              <Text>{i18n.t<string>("klingenstaerke")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.klingenstaerke ? item.klingenstaerke.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------breite------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "breite",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("breite");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  <Image
                    width="400px"
                    src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MAX_BREITE.JPG`}
                  ></Image>
                  <div>{i18n.t<string>("breiteTooltip")}</div>
                </div>
              }
            >
              <Text> {i18n.t<string>("breiteCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return <Text>{item.breite ? item.breite.toLocaleString() : "-"}</Text>;
      },
    }),
    // ------------achsabstand------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "achsabstand",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("achsabstand");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  <Image
                    width="400px"
                    src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MIN_MAX_ACHSABSTAND.JPG`}
                  ></Image>
                  <div>{i18n.t<string>("achsabstandTooltip")}</div>
                </div>
              }
            >
              <Text> {i18n.t<string>("achsabstand")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.achsabstand ? item.achsabstand.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------auskraglaenge------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "auskraglaenge",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("auskraglaenge");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  <Image
                    width="400px"
                    src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MIN_AUSKRAGUNG.JPG`}
                  ></Image>
                  <div>{i18n.t<string>("auskraglaengeTooltip")}</div>
                </div>
              }
            >
              <Text> {i18n.t<string>("auskraglaenge")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.auskraglaenge ? item.auskraglaenge.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------laenge------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "laenge",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("laenge");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  {folder == "ZAB" && (
                    <Image
                      width="400px"
                      src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MAX_LAENGE.JPG`}
                    ></Image>
                  )}

                  <div>{i18n.t<string>("laenge")}</div>
                </div>
              }
            >
              <Text> {i18n.t<string>("laenge")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return <Text>{item.laenge ? item.laenge.toLocaleString() : "-"}</Text>;
      },
    }),
    // ------------aussenlaenge------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "aussenlaenge",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("aussenlaenge");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={
                <div>
                  {folder == "ZAB" && (
                    <Image
                      width="400px"
                      src={`${baseUrl}/IMAGES/HELPIMAGES/${folder}/MIN_AUSSENLAENGE.JPG`}
                    ></Image>
                  )}
                  <div>{i18n.t<string>("aussenlaengeColTooltip")}</div>
                </div>
              }
            >
              <Text> {i18n.t<string>("aussenlaengeCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.aussenlaenge ? item.aussenlaenge.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------profiltiefe------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "profiltiefe",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("profiltiefe");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("profiltiefeColTooltip")}</div>}
            >
              <Text> {i18n.t<string>("profiltiefeCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.profiltiefe ? item.profiltiefe.toLocaleString() : "-"}
          </Text>
        );
      },
    }),
    // ------------nennweite------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "nennweite",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("nennweite");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("nennweiteColTooltip")}</div>}
            >
              <Text> {i18n.t<string>("nennweiteCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <Text>{item.nennweite ? item.nennweite.toLocaleString() : "-"}</Text>
        );
      },
    }),
    // ------------nennweiteInch------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "nennweiteInch",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("nennweite");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("nennweiteInchColTooltip")}</div>}
            >
              <Text> {i18n.t<string>("nennweiteInchCol")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        let inch = "";
        if (item?.nennweite && item?.nennweite > 0) {
          const mm = helperMethods.nachkomma(item.nennweite, 2);
          inch = MmInch.toInch(helperMethods.convertToNumber(mm));
        }
        return (
          <div>
            <Text>{inch}</Text>
          </div>
        );
      },
    }),

    // ------------nennweiteAbtrieb------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "nennweiteAbtrieb",
      renderHeaderCell: () => {
        return (
          <Tooltip
            relationship="label"
            content={<div>{i18n.t<string>("nennweiteColTooltip")}</div>}
          >
            <Text> {i18n.t<string>("nennweiteCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return (
          <div>
            <Text>
              {/* {item.nennweiteAbtrieb
                ? item.nennweiteAbtrieb.toLocaleString()
                : "-"} */}
            </Text>
          </div>
        );
      },
    }),
    // ------------anzahlStufen------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "anzahlStufen",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("anzahlStufen");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("anzahlStufenTooltip")}</div>}
            >
              <Text> {i18n.t<string>("anzahlStufen")}</Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        return (
          <div>
            <Text>{item.anzahlStufen ? item.anzahlStufen : "-"}</Text>
          </div>
        );
      },
    }),
    // ------------preis------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "preis",
      renderHeaderCell: () => {
        return (
          <div
            onClick={() => {
              if (props.onOrderBy) {
                props.onOrderBy("netto");
              }
            }}
            style={{ width: "100%", height: "100%" }}
          >
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("preisTooltip")}</div>}
            >
              <Text>
                {i18n.t<string>("preis")}
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
              </Text>
            </Tooltip>
          </div>
        );
      },
      renderCell: (item) => {
        if (item.hasOwnProperty("artikel") && item.artikel) {
          return (
            <div className="lueb-centerVertical">
              <Text>
                {item.artikel?.netto
                  ? item.artikel?.netto.toLocaleString(
                      i18n.language.includes("de") ? "de-DE" : "en-EN",
                      { minimumFractionDigits: 2 }
                    ) + " €"
                  : ""}
              </Text>
            </div>
          );
        } else {
          return (
            <div className="lueb-centerVertical">
              <Text>
                {item.netto
                  ? item.netto.toFixed(2).toLocaleString() + " €"
                  : ""}
              </Text>
            </div>
          );
        }
      },
    }),
  ];

  function getColumns() {
    let filteredColumns = props.showButtons
      ? columns
      : columns.filter((x) => x.columnId != "actions");

    filteredColumns = props.preiseSichtbar
      ? filteredColumns
      : filteredColumns.filter((x) => x.columnId != "preis");
    if (windowSize.width <= 500) {
      filteredColumns = filteredColumns.filter(
        (x) =>
          x.columnId != "benennungMl" &&
          x.columnId != "benennungDE" &&
          x.columnId != "benennungEN"
      );
    }

    switch (props.type) {
      case "allLsp3":
        return filteredColumns.filter((x) =>
          allLsp3ColumnNames.includes(x.columnId.toString())
        );
      case "lsp3_o_inline":
        return filteredColumns.filter((x) =>
          lsp3_o_ColumnNames.includes(x.columnId.toString())
        );
      case "lsp3_c_inline":
        return filteredColumns.filter((x) =>
          lsp3_c_ColumnNames.includes(x.columnId.toString())
        );
      case "lsp3_o_outline":
        return filteredColumns.filter((x) =>
          lsp3_o_ColumnNames.includes(x.columnId.toString())
        );
      case "lsp3_c_outline":
        return filteredColumns.filter((x) =>
          lsp3_c_ColumnNames.includes(x.columnId.toString())
        );
      case "abtriebszahnrad":
        return filteredColumns.filter((x) =>
          abtriebszahnradColumnNames.includes(x.columnId.toString())
        );
      case "abtriebgegenhalter":
        return filteredColumns.filter((x) =>
          abtriebgegenhalterColumnNames.includes(x.columnId.toString())
        );
      case "lsp3_straight":
        return filteredColumns.filter((x) =>
          straightColumnNames.includes(x.columnId.toString())
        );
    }

    return filteredColumns;
  }

  return getColumns();
}
export default QuickFinderColumns;
